"use client";
/* Auto-generated. Do not edit. */
/* Source: src/pages/home-modules/home-one/sections/footerSection.tsx */

import { SmartImage } from "@/Components";
import { SmartLink } from "@/Components";
import { renderCollectionNode, renderItemNode, renderNode } from "@/Templates/section-node-renderers";
import { FC, ComponentProps, Key, ReactNode } from "react";

type FooterSection336sItem = {
    key: Key | null | undefined;
    /** Detected variants: "Company" | "Treatments" | "Specialities" | "Utilites" */
    h60Text: ReactNode;
    /** Detected variants: "col-lg-3 col-md-3 col-sm-6" */
    className?: string;
    /** Detected variants: "footer-widget footer-menu" */
    div0ClassName?: string;
    /** Detected variants: "footer-title" */
    h60ClassName?: string;
    footerWidgetItems?: FooterSectionUlsItem[];
};

type FooterSectionUlsItem = {
    key: Key | null | undefined;
    /** Detected variants: "About" | "Features" | "Works" | "Careers" | "Locations" | "Dental" | "Cardiac" | "Spinal Cord" | "Hair Growth" | "Anemia & Disorder" | "Transplant" | "Cardiologist" | "Oncology" | "Pediatrics" | "Gynacology" | "Pricing" | "Contact" | "Request A Quote" | "Premium Membership" | "Integrations" */
    link0Text: ReactNode;
    /** Detected variants: "all_routes.aboutUs" | "all_routes.search1" | "#" | "all_routes.pricing" | "all_routes.contactUs" */
    href: string;
};

type FooterSectionUls6Item = {
    key: Key | null | undefined;
    /** Detected variants: "Legal Notice" | "Privacy Policy" | "Refund Policy" */
    link0Text: ReactNode;
    /** Detected variants: "#" | "all_routes.privacyPolicy" */
    href: string;
};

type FooterSectionUls5Item = {
    key: Key | null | undefined;
    /** Detected variants: "fa-brands fa-facebook" | "fa-brands fa-x-twitter" | "fa-brands fa-instagram" | "fa-brands fa-linkedin" | "fa-brands fa-pinterest" */
    className: string;
    /** Detected variants: "#" */
    href?: string;
};

type FooterSectionUls7Item = {
    key: Key | null | undefined;
    /** Detected variants: "/Templates/Doccure/img/icons/card-01.svg" | "/Templates/Doccure/img/icons/card-02.svg" | "/Templates/Doccure/img/icons/card-03.svg" | "/Templates/Doccure/img/icons/card-04.svg" | "/Templates/Doccure/img/icons/card-05.svg" | "/Templates/Doccure/img/icons/card-06.svg" */
    src: string;
    /** Detected variants: "#" */
    href?: string;
    /** Detected variants: "Img" */
    alt?: string;
};
export type HomeOneFooterSectionGeneratedProps = {
    divDiv0H60H6Props?: Partial<ComponentProps<"h6">> | ((item: FooterSection336sItem) => Partial<ComponentProps<"h6">>);
    footerDiv0Div0Div0ClassName?: string;
    footerDiv0Div0Div0Div0Div0ClassName?: string;
    footerDiv0Div0Div0Div1Div0Div0Form0FormVisible?: boolean;
    footerDiv0Div0Div0Div1Div0Div0Form0FormRenderer?: (defaultNode: ReactNode) => ReactNode;
    footerDiv0Div0Div0Div1Div0Div0Form0FormProps?: Partial<ComponentProps<"form">>;
    /** Default: "Send" */
    footerDiv0Div0Div0Div1Div0Div0Form0Button0ButtonText?: ReactNode;
    footerDiv0Div0Div0Div1Div0Div0Form0Button0ButtonVisible?: boolean;
    footerDiv0Div0Div0Div1Div0Div0Form0Button0ButtonRenderer?: (defaultNode: ReactNode) => ReactNode;
    footerDiv0Div0Div0Div1Div0Div0Form0Button0ButtonProps?: Partial<ComponentProps<"button">>;
    /** Default: "Enter Email Address" */
    footerDiv0Div0Div0Div1Div0Div0Form0Input0InputPlaceholder?: string;
    /** Default: "Connect With Us" */
    footerDiv0Div0Div0Div1Div0Div1H60H6Text?: ReactNode;
    footerDiv0Div0Div0Div1Div0Div1H60H6Visible?: boolean;
    footerDiv0Div0Div0Div1Div0Div1H60H6Renderer?: (defaultNode: ReactNode) => ReactNode;
    footerDiv0Div0Div0Div1Div0Div1H60H6Props?: Partial<ComponentProps<"h6">>;
    /** Default: "Newsletter" */
    footerDiv0Div0Div0Div1Div0H60H6Text?: ReactNode;
    footerDiv0Div0Div0Div1Div0H60H6Visible?: boolean;
    footerDiv0Div0Div0Div1Div0H60H6Renderer?: (defaultNode: ReactNode) => ReactNode;
    footerDiv0Div0Div0Div1Div0H60H6Props?: Partial<ComponentProps<"h6">>;
    /** Default: "Subscribe & Stay Updated from the Doccure" */
    footerDiv0Div0Div0Div1Div0P0PText?: ReactNode;
    /** Default: "Copyright © 2026 Doccure. All Rights Reserved" */
    footerDiv1Div0Div0Div0P0PText?: ReactNode;
    footerSectionUls5LiLink0LinkProps?: Partial<ComponentProps<typeof SmartLink>> | ((item: FooterSectionUls5Item) => Partial<ComponentProps<typeof SmartLink>>);
    footerSectionUls6LiLink0LinkProps?: Partial<ComponentProps<typeof SmartLink>> | ((item: FooterSectionUls6Item) => Partial<ComponentProps<typeof SmartLink>>);
    footerSectionUls7LiLink0LinkProps?: Partial<ComponentProps<typeof SmartLink>> | ((item: FooterSectionUls7Item) => Partial<ComponentProps<typeof SmartLink>>);
    liLink0LinkProps?: Partial<ComponentProps<typeof SmartLink>> | ((item: FooterSectionUlsItem) => Partial<ComponentProps<typeof SmartLink>>);
    liLink0ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: FooterSectionUls7Item) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
    footerSection336s: FooterSection336sItem[];
    footerSectionUls6: FooterSectionUls6Item[];
    footerSectionUls5: FooterSectionUls5Item[];
    footerSectionUls7: FooterSectionUls7Item[];
    footerSection336sItemWrapper?: (item: FooterSection336sItem, content: ReactNode) => ReactNode;
    footerSection336sRenderer?: (defaultNode: ReactNode) => ReactNode;
    footerSection336sH6Visible?: boolean;
    footerSection336sH6Renderer?: (item: FooterSection336sItem, defaultNode: ReactNode) => ReactNode;
    footerSection336sH6Props?: Partial<ComponentProps<"h6">> | ((item: FooterSection336sItem) => Partial<ComponentProps<"h6">>);
    footerSectionUlsItemWrapper?: (item: FooterSectionUlsItem, content: ReactNode) => ReactNode;
    footerSectionUlsRenderer?: (defaultNode: ReactNode) => ReactNode;
    footerSectionUlsLinkVisible?: boolean;
    footerSectionUlsLinkRenderer?: (item: FooterSectionUlsItem, defaultNode: ReactNode) => ReactNode;
    footerSectionUlsLinkProps?: Partial<ComponentProps<typeof SmartLink>> | ((item: FooterSectionUlsItem) => Partial<ComponentProps<typeof SmartLink>>);
    footerSectionUls6ItemWrapper?: (item: FooterSectionUls6Item, content: ReactNode) => ReactNode;
    footerSectionUls6Renderer?: (defaultNode: ReactNode) => ReactNode;
    footerSectionUls6LinkVisible?: boolean;
    footerSectionUls6LinkRenderer?: (item: FooterSectionUls6Item, defaultNode: ReactNode) => ReactNode;
    footerSectionUls6LinkProps?: Partial<ComponentProps<typeof SmartLink>> | ((item: FooterSectionUls6Item) => Partial<ComponentProps<typeof SmartLink>>);
    footerSectionUls5ItemWrapper?: (item: FooterSectionUls5Item, content: ReactNode) => ReactNode;
    footerSectionUls5Renderer?: (defaultNode: ReactNode) => ReactNode;
    footerSectionUls5LinkVisible?: boolean;
    footerSectionUls5LinkRenderer?: (item: FooterSectionUls5Item, defaultNode: ReactNode) => ReactNode;
    footerSectionUls5LinkProps?: Partial<ComponentProps<typeof SmartLink>> | ((item: FooterSectionUls5Item) => Partial<ComponentProps<typeof SmartLink>>);
    footerSectionUls7ItemWrapper?: (item: FooterSectionUls7Item, content: ReactNode) => ReactNode;
    footerSectionUls7Renderer?: (defaultNode: ReactNode) => ReactNode;
    footerSectionUls7LinkVisible?: boolean;
    footerSectionUls7LinkRenderer?: (item: FooterSectionUls7Item, defaultNode: ReactNode) => ReactNode;
    footerSectionUls7ImageVisible?: boolean;
    footerSectionUls7ImageRenderer?: (item: FooterSectionUls7Item, defaultNode: ReactNode) => ReactNode;
    footerSectionUls7LinkProps?: Partial<ComponentProps<typeof SmartLink>> | ((item: FooterSectionUls7Item) => Partial<ComponentProps<typeof SmartLink>>);
    footerSectionUls7ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: FooterSectionUls7Item) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
};

const HomeOneFooterSectionGenerated: FC<HomeOneFooterSectionGeneratedProps> = ({
    footerDiv0Div0Div0Div1Div0Div0Form0Button0ButtonText = "Send",
    footerDiv0Div0Div0Div1Div0Div0Form0Button0ButtonVisible,
    footerDiv0Div0Div0Div1Div0Div0Form0Button0ButtonRenderer,
    footerDiv0Div0Div0Div1Div0Div0Form0Button0ButtonProps,
    footerDiv0Div0Div0Div1Div0Div0Form0Input0InputPlaceholder = "Enter Email Address",
    footerDiv0Div0Div0Div1Div0Div1H60H6Text = "Connect With Us",
    footerDiv0Div0Div0Div1Div0Div1H60H6Visible,
    footerDiv0Div0Div0Div1Div0Div1H60H6Renderer,
    footerDiv0Div0Div0Div1Div0Div1H60H6Props,
    footerDiv0Div0Div0Div1Div0H60H6Text = "Newsletter",
    footerDiv0Div0Div0Div1Div0H60H6Visible,
    footerDiv0Div0Div0Div1Div0H60H6Renderer,
    footerDiv0Div0Div0Div1Div0H60H6Props,
    footerDiv0Div0Div0Div1Div0P0PText = "Subscribe & Stay Updated from the Doccure",
    footerDiv1Div0Div0Div0P0PText = "Copyright © 2026 Doccure. All Rights Reserved",
    footerDiv0Div0Div0Div1Div0Div0Form0FormVisible,
    footerDiv0Div0Div0Div1Div0Div0Form0FormRenderer,
    footerDiv0Div0Div0Div1Div0Div0Form0FormProps,
    divDiv0H60H6Props,
    footerSectionUls5LiLink0LinkProps,
    footerSectionUls6LiLink0LinkProps,
    footerSectionUls7LiLink0LinkProps,
    liLink0LinkProps,
    liLink0ImageWithBasePath0ImageProps,
    footerDiv0Div0Div0ClassName,
    footerDiv0Div0Div0Div0Div0ClassName,
    footerSection336s,
    footerSectionUls6,
    footerSectionUls5,
    footerSectionUls7,
    footerSection336sItemWrapper,
    footerSection336sRenderer,
    footerSection336sH6Visible,
    footerSection336sH6Renderer,
    footerSection336sH6Props,
    footerSectionUlsItemWrapper,
    footerSectionUlsRenderer,
    footerSectionUlsLinkVisible,
    footerSectionUlsLinkRenderer,
    footerSectionUlsLinkProps,
    footerSectionUls6ItemWrapper,
    footerSectionUls6Renderer,
    footerSectionUls6LinkVisible,
    footerSectionUls6LinkRenderer,
    footerSectionUls6LinkProps,
    footerSectionUls5ItemWrapper,
    footerSectionUls5Renderer,
    footerSectionUls5LinkVisible,
    footerSectionUls5LinkRenderer,
    footerSectionUls5LinkProps,
    footerSectionUls7ItemWrapper,
    footerSectionUls7Renderer,
    footerSectionUls7LinkVisible,
    footerSectionUls7LinkRenderer,
    footerSectionUls7ImageVisible,
    footerSectionUls7ImageRenderer,
    footerSectionUls7LinkProps,
    footerSectionUls7ImageProps,
}) => {
    return (
        <footer className="footer inner-footer footer-info">
            <div className="footer-top">
                <div className="container">
                    <div className={footerDiv0Div0Div0ClassName ?? "row"}>
                        <div className="col-xl-8">
                            <div className={footerDiv0Div0Div0Div0Div0ClassName ?? "row"}>
                                {renderCollectionNode(
                                    footerSection336s,
                                    (item: FooterSection336sItem) => (
                                        <div className={item.className ?? "col-lg-3 col-md-3 col-sm-6"} key={item.key}>
                                            <div className={item.div0ClassName ?? "footer-widget footer-menu"}>
                                                {renderItemNode(footerSection336sH6Visible, footerSection336sH6Renderer, item, (
                                                    <h6 className={item.h60ClassName ?? "footer-title"} {...(typeof footerSection336sH6Props === "function" ? footerSection336sH6Props(item) : (footerSection336sH6Props ?? {}))} {...(typeof divDiv0H60H6Props === "function" ? divDiv0H60H6Props(item) : (divDiv0H60H6Props ?? {}))}>{item.h60Text}</h6>
                                                ))}
                                                <ul>
                                                    {renderCollectionNode(
                                                        item.footerWidgetItems ?? [],
                                                        (item: FooterSectionUlsItem) => (
                                                            <li key={item.key}>
                                                                {renderItemNode(footerSectionUlsLinkVisible, footerSectionUlsLinkRenderer, item, (
                                                                    <SmartLink href={item.href} {...(typeof footerSectionUlsLinkProps === "function" ? footerSectionUlsLinkProps(item) : (footerSectionUlsLinkProps ?? {}))} {...(typeof liLink0LinkProps === "function" ? liLink0LinkProps(item) : (liLink0LinkProps ?? {}))}>{item.link0Text}</SmartLink>
                                                                ))}
                                                            </li>
                                                        ),
                                                        footerSectionUlsItemWrapper,
                                                        footerSectionUlsRenderer
                                                    )}
                                                </ul>
                                            </div>
                                        </div>
                                    ),
                                    footerSection336sItemWrapper,
                                    footerSection336sRenderer
                                )}
                            </div>
                        </div>
                        <div className="col-xl-4 col-md-7">
                            <div className="footer-widget">
                                {renderNode(footerDiv0Div0Div0Div1Div0H60H6Visible, footerDiv0Div0Div0Div1Div0H60H6Renderer, (
                                    <h6 className="footer-title" {...(footerDiv0Div0Div0Div1Div0H60H6Props ?? {})}>{footerDiv0Div0Div0Div1Div0H60H6Text}</h6>
                                ))}
                                <p className="mb-2 text-dark">{footerDiv0Div0Div0Div1Div0P0PText}</p>
                                <div className="subscribe-input">
                                    {renderNode(footerDiv0Div0Div0Div1Div0Div0Form0FormVisible, footerDiv0Div0Div0Div1Div0Div0Form0FormRenderer, (
                                        <form action="#" {...(footerDiv0Div0Div0Div1Div0Div0Form0FormProps ?? {})}>
                                            <input type="email" className="form-control" placeholder={footerDiv0Div0Div0Div1Div0Div0Form0Input0InputPlaceholder} />
                                            {renderNode(footerDiv0Div0Div0Div1Div0Div0Form0Button0ButtonVisible, footerDiv0Div0Div0Div1Div0Div0Form0Button0ButtonRenderer, (
                                                <button type="submit" className="btn btn-md btn-primary-gradient d-inline-flex align-items-center" {...(footerDiv0Div0Div0Div1Div0Div0Form0Button0ButtonProps ?? {})}>
                                                    <i className="isax isax-send-25 me-1" />
                                                    {footerDiv0Div0Div0Div1Div0Div0Form0Button0ButtonText}
                                                </button>
                                            ))}
                                        </form>
                                    ))}
                                </div>
                                <div className="social-icon">
                                    {renderNode(footerDiv0Div0Div0Div1Div0Div1H60H6Visible, footerDiv0Div0Div0Div1Div0Div1H60H6Renderer, (
                                        <h6 className="mb-3 footer-title" {...(footerDiv0Div0Div0Div1Div0Div1H60H6Props ?? {})}>{footerDiv0Div0Div0Div1Div0Div1H60H6Text}</h6>
                                    ))}
                                    <ul>
                                        {renderCollectionNode(
                                            footerSectionUls5,
                                            (item: FooterSectionUls5Item) => (
                                                <li key={item.key}>
                                                    {renderItemNode(footerSectionUls5LinkVisible, footerSectionUls5LinkRenderer, item, (
                                                        <SmartLink href={item.href ?? "#"} {...(typeof footerSectionUls5LinkProps === "function" ? footerSectionUls5LinkProps(item) : (footerSectionUls5LinkProps ?? {}))} {...(typeof footerSectionUls5LiLink0LinkProps === "function" ? footerSectionUls5LiLink0LinkProps(item) : (footerSectionUls5LiLink0LinkProps ?? {}))}>
                                                            <i className={item.className} />
                                                        </SmartLink>
                                                    ))}
                                                </li>
                                            ),
                                            footerSectionUls5ItemWrapper,
                                            footerSectionUls5Renderer
                                        )}
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="footer-bottom">
                <div className="container">
                    <div className="copyright">
                        <div className="copyright-text mb-0">
                            <p className="mb-0">{footerDiv1Div0Div0Div0P0PText}</p>
                        </div>
                        <div className="copyright-menu">
                            <ul className="policy-menu mb-0">
                                {renderCollectionNode(
                                    footerSectionUls6,
                                    (item: FooterSectionUls6Item) => (
                                        <li key={item.key}>
                                            {renderItemNode(footerSectionUls6LinkVisible, footerSectionUls6LinkRenderer, item, (
                                                <SmartLink href={item.href} {...(typeof footerSectionUls6LinkProps === "function" ? footerSectionUls6LinkProps(item) : (footerSectionUls6LinkProps ?? {}))} {...(typeof footerSectionUls6LiLink0LinkProps === "function" ? footerSectionUls6LiLink0LinkProps(item) : (footerSectionUls6LiLink0LinkProps ?? {}))}>{item.link0Text}</SmartLink>
                                            ))}
                                        </li>
                                    ),
                                    footerSectionUls6ItemWrapper,
                                    footerSectionUls6Renderer
                                )}
                            </ul>
                        </div>
                        <ul className="payment-method">
                            {renderCollectionNode(
                                footerSectionUls7,
                                (item: FooterSectionUls7Item) => (
                                    <li key={item.key}>
                                        {renderItemNode(footerSectionUls7LinkVisible, footerSectionUls7LinkRenderer, item, (
                                            <SmartLink href={item.href ?? "#"} {...(typeof footerSectionUls7LinkProps === "function" ? footerSectionUls7LinkProps(item) : (footerSectionUls7LinkProps ?? {}))} {...(typeof footerSectionUls7LiLink0LinkProps === "function" ? footerSectionUls7LiLink0LinkProps(item) : (footerSectionUls7LiLink0LinkProps ?? {}))}>
                                                {renderItemNode(footerSectionUls7ImageVisible, footerSectionUls7ImageRenderer, item, (
                                                    <SmartImage src={item.src} alt={item.alt ?? "Img"} {...(typeof footerSectionUls7ImageProps === "function" ? footerSectionUls7ImageProps(item) : (footerSectionUls7ImageProps ?? {}))} {...(typeof liLink0ImageWithBasePath0ImageProps === "function" ? liLink0ImageWithBasePath0ImageProps(item) : (liLink0ImageWithBasePath0ImageProps ?? {}))} />
                                                ))}
                                            </SmartLink>
                                        ))}
                                    </li>
                                ),
                                footerSectionUls7ItemWrapper,
                                footerSectionUls7Renderer
                            )}
                        </ul>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default HomeOneFooterSectionGenerated;
